import React from 'react';
import { Container } from 'react-bootstrap';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer mt-auto py-3 bg-dark text-light">
      <Container className="text-center">
        <span>iReminder App ({currentYear}) - Developed by </span>
        <a 
          href="mailto:onderxyilmaz@gmail.com"
          className="text-light text-decoration-none"
          style={{ borderBottom: '1px dotted #fff' }}
        >
          Onder Yilmaz
        </a>
      </Container>
    </footer>
  );
};

export default Footer; 